import React from "react";
import { FormViewType } from "../Tickets/Tickets";
import { useDarkModeStore } from "../../../store/useDarkModeStore";
import KanbanBoardPage from "../Kanban/KanbanBoardPage";

interface TableViewFormProps {
  formView: FormViewType;
  setFormView: React.Dispatch<React.SetStateAction<FormViewType>>;
}

export const Kanban: React.FC<TableViewFormProps> = ({ formView, setFormView }) => {
  const { darkMode } = useDarkModeStore();

  return (
    <React.Fragment>
      <KanbanBoardPage formView={formView} setFormView={setFormView} darkMode={darkMode} />
    </React.Fragment>
  );
};
export default Kanban;
